import type { DomainAccountModuleEntryV2 } from "@exopengithub/planning-api-shared";
import { createEntityAdapter } from "@reduxjs/toolkit";

export const accountModuleEntriesV2Adapter =
	createEntityAdapter<DomainAccountModuleEntryV2>();

export const accountModuleEntriesV2Selectors =
	accountModuleEntriesV2Adapter.getSelectors();
